import { render } from "./main-theme.vue?vue&type=template&id=99689b8c"
import script from "./main-theme.vue?vue&type=script&lang=js"
export * from "./main-theme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__